import React, { useState, useRef, useEffect } from "react";
import { getNounsPool } from "../EnglishTool/pool/nounsPool";
import { getVerbsPool } from "../EnglishTool/pool/verbsPool";
import { getAdjectivesPool } from "../EnglishTool/pool/adjectivesPool";
import { getAdverbsPool } from "../EnglishTool/pool/adverbsPool";
import SpeakButton from "../EnglishTool/SpeakButton";
import { awardToken } from "../../awardtoken";
import { db } from "../../firebase";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { useAuth } from "../../components/useAuth";
const grade = 3; // Could be dynamic

const TOOL_TYPE = "EnglishListeningPractice";

async function logListeningPractice({ user, score, total, startTime, endTime }) {
  if (!user?.uid) {
    console.warn("No user UID! User:", user);
    return;
  }
  if (total === 0) {
    console.warn("No attempts, nothing to log.");
    return;
  }
  try {
    await setDoc(
      doc(db, "users", user.uid, "practiceRecords", TOOL_TYPE),
      {
        toolType: TOOL_TYPE,
        topic: "english listening",
        numQuestions: total,
        correct: score,
        attempts: total,
        timestamp: serverTimestamp(),
        startedAt: startTime,
        finishedAt: endTime,
        durationSec: Math.round((endTime - startTime) / 1000),
      },
      { merge: true }
    );
    console.log("Listening session log successfully written to Firestore.");
  } catch (e) {
    console.error("Error writing listening session log:", e);
  }
}


function wrapWordArray(arr) {
  return (arr || []).map(w => (typeof w === "string" ? { word: w } : w));
}

const nouns = getNounsPool(grade);
const verbs = wrapWordArray(getVerbsPool(grade));
const adjectives = wrapWordArray(getAdjectivesPool(grade));
const adverbs = wrapWordArray(getAdverbsPool(grade));
const ALL = [...nouns, ...verbs, ...adjectives, ...adverbs];

function randomSet() {
  const correct = ALL[Math.floor(Math.random() * ALL.length)];
  const choices = [correct.word];
  while (choices.length < 4) {
    const candidate = ALL[Math.floor(Math.random() * ALL.length)].word;
    if (!choices.includes(candidate)) choices.push(candidate);
  }
  return {
    correct,
    choices: choices.sort(() => Math.random() - 0.5),
  };
}

export default function EnglishListeningPractice({ onAwardTokens }) {
  const [q, setQ] = useState(randomSet());
  const [feedback, setFeedback] = useState(null);
  const [score, setScore] = useState(0);
  const tokensAwarded = useRef(0);
  const { user } = useAuth();
  const [sessionStart, setSessionStart] = useState(Date.now());
  const [total, setTotal] = useState(0);
  const sessionStats = useRef({ score: 0, total: 0 });
  const didMountRef = useRef(false);

  useEffect(() => {
  return () => {
    const endTime = Date.now();
    if (sessionStats.current.total > 0) {
      logListeningPractice({
        user,
        score: sessionStats.current.score,
        total: sessionStats.current.total,
        startTime: sessionStart,
        endTime,
      });
    }
  };
  // eslint-disable-next-line
}, []);


function check(ans) {
  const isCorrect = ans === q.correct.word;
  const nextTotal = total + 1;
  const nextScore = isCorrect ? score + 1 : score;

  setTotal(nextTotal);
  setScore(nextScore);
  sessionStats.current = { score: nextScore, total: nextTotal };

  // Log every answer to Firestore with the latest score/total
  const endTime = Date.now();
  logListeningPractice({
    user,
    score: nextScore,
    total: nextTotal,
    startTime: sessionStart,
    endTime,
  });

  if (isCorrect) {
    setFeedback("✅ Correct!");
    if (nextScore >= (tokensAwarded.current + 1) * 10) {
      tokensAwarded.current += 1;
      awardToken();
      if (onAwardTokens) onAwardTokens(1);
    }
    setTimeout(() => {
      setQ(randomSet());
      setFeedback(null);
    }, 1000);
  } else {
    setFeedback(`❌ Incorrect. The correct answer was: ${q.correct.word}`);
  }
}



  return (
    <div className="english-practice-card">
      <h2>Listening Practice</h2>
      <div style={{ marginBottom: 10 }}>Listen and choose the correct word:</div>
      <SpeakButton text={q.correct.word} />
      <div>
        {q.choices.map(choice =>
          <button
            key={choice}
            style={{ margin: 8, minWidth: 90 }}
            onClick={() => check(choice)}
          >
            {choice}
          </button>
        )}
      </div>
      {feedback && <div style={{ marginTop: 10 }}>{feedback}</div>}
      <div style={{ marginTop: 10 }}>Score: {score}</div>
      <button
  className="math-pill-btn"
  style={{ margin: "1em 0" }}
  onClick={() => {
    const endTime = Date.now();
    if (sessionStats.current.total > 0) {
      logListeningPractice({
        user,
        score: sessionStats.current.score,
        total: sessionStats.current.total,
        startTime: sessionStart,
        endTime,
      });
      setSessionStart(Date.now());
      setTotal(0);
      setScore(0);
      sessionStats.current = { score: 0, total: 0 };
      tokensAwarded.current = 0;
    }
  }}
>
  Finish Session
</button>

    </div>
  );
}
